import { Component, OnInit, forwardRef, Inject } from "@angular/core";
import { HomeComponent } from "../home.component";
import { AuthService } from "../../core/security/auth.service";
import { MessagingService } from "../service/messaging.service";
import { Notification } from "app/fiscalia/domain/notification";
import { Router } from "@angular/router";
import { QueryOptions } from "app/core/commons/query.options";
import { merge } from "rxjs/operators";

@Component({
  selector: "home-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"]
})
export class NavComponent implements OnInit {
  // Options
  queryOptions: QueryOptions;

  // Notifications
  newNotifications = 0;
  items: Notification[] = [];

  constructor(
    @Inject(forwardRef(() => HomeComponent)) public app: HomeComponent,
    private authService: AuthService,
    private msgService: MessagingService,
    private router: Router
  ) {}

  ngOnInit() {
    this.queryOptions = new QueryOptions();
    this.initFCM();
    this.initNotificationPanel();
  }

  public logout() {
    this.authService.logout();
  }

  /**
   * Notifications methods
   */
  private initFCM(): void {
    this.msgService.getPermission();
    this.msgService.receiveMessage();
    this.msgService.currentMessageObservable().subscribe(
      x => {
        if (x.id != null && x.title != null && x.body != null) {
          this.items.unshift(x);
          this.refreshNewNotifications();
        }
      },
      err => console.error("Observer got an error: " + err)
    );

    this.msgService.currentConversationId.subscribe(() => {
      setTimeout(() => this.initNotificationPanel(), 1000);
    })

    this.msgService.updateSubject.subscribe(() => setTimeout(() => this.initNotificationPanel(), 1000))

    navigator.serviceWorker.addEventListener("message", event => {
      if(this.msgService.currentConversationId.getValue() != null) {
        setTimeout(() => this.initNotificationPanel(), 500);
      } else {
        this.initNotificationPanel();
      }
    });
  }

  initNotificationPanel(): void {
    this.queryOptions.page = 0;
    this.queryOptions.size = 10;
    this.msgService.query().subscribe(items => {
      this.items = items.content;
      this.refreshNewNotifications();
    });
  }

  refreshNewNotifications(): void {
    let n = 0;
    let is: number;
    this.items.map(function(item) {
      is = Number(item.viewed);
      if (is === 0) {
        n++;
      }
    });
    this.newNotifications = n;
  }

  showNotificationIcon(): boolean {
    return this.newNotifications > 0;
  }

  getColor(is: number) {
    let i: number = Number(is);
    if (i === 0) {
      return "#E5E5E5";
    }
  }

  getDate(e: number): string {
    let date = new Date(e);
    let s: string =
      date.getDate() +
      "/" +
      (date.getMonth() + 1) +
      "/" +
      date.getFullYear() +
      "  " +
      date.getHours() +
      ":" +
      date.getMinutes() +
      " hs.";
    return s;
  }

  navigate(item: Notification) {
    this.setViewed(item.id);
    this.msgService.setViewed(item.id).subscribe();
    let splitted = item.redirectTo.split("/");
    this.router.navigate(splitted);
  }

  private setViewed(id: number): void {
    let i: number = 0;
    let e: boolean = false;
    while (i < this.items.length && !e) {
      if (this.items[i].id == id) {
        this.items[i].viewed = 1;
        e = true;
      }
      i++;
    }
    this.refreshNewNotifications();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/nav/nav.component.ts